<script>
import Utils from '@/common/Utils';

export default {
    props: ['input'],
    data() {
        return {
            pieLabelPlugin: {
                id: 'pieLabelPlugin',
                afterDraw(chart) {
                    {
                        const { ctx } = chart

                        chart.data.datasets.forEach((dataset, i) => {
                            chart.getDatasetMeta(i).data.forEach((arc, index) => {
                                const label = chart.data.labels[index]
                                const value = parseInt(dataset.data[index]) + '%'

                                const startAngle = arc.startAngle
                                const endAngle = arc.endAngle
                                const angle = endAngle - startAngle

                                const position = arc.tooltipPosition()
                                const midAngle = (startAngle + endAngle) / 2

                                ctx.save()
                                ctx.fillStyle = 'white'
                                ctx.font = 'bold 12px sans-serif'
                                ctx.textAlign = 'center'
                                ctx.textBaseline = 'middle'

                                if (angle > 0.25) {
                                    const lines = [label, value]
                                    lines.forEach((line, i) => {
                                        ctx.fillText(line, position.x, position.y + i * 14)
                                    })
                                } else {
                                    const offset = index * 15
                                    const x = position.x + Math.cos(midAngle) * offset
                                    const y = position.y + Math.sin(midAngle) * offset

                                    ctx.fillStyle = '#ffffff';
                                    ctx.fillText(`${label}: ${value}`, x, y)
                                }

                                ctx.restore()
                            })
                        })
                    }
                }
            }
        }
    },
    created() {


    },
    computed: {
        data() {
            const documentStyle = getComputedStyle(document.documentElement);
            const filteredInput = this.input.filter(i => !i.key.toUpperCase().includes('NO DEMURRAGE'));

            let colors = [
                'rgba(145,226,237, 0.4)',
                'rgba(251,199,145, 0.4)',
                'rgba(178,221,180, 0.4)',
                'rgba(246,158,188, 0.4)',
                'rgba(187,199,205, 0.4)',
                'rgba(212,162,221, 0.4)'
            ];

            let borderColors = [
                documentStyle.getPropertyValue('--cyan-500'),
                documentStyle.getPropertyValue('--orange-500'),
                documentStyle.getPropertyValue('--green-500'),
                documentStyle.getPropertyValue('--pink-500'),
                documentStyle.getPropertyValue('--bluegray-500'),
                documentStyle.getPropertyValue('--purple-500'),
            ]

            let labels = filteredInput.map(i => i.key);

            let datasets = [
                {
                    data: filteredInput.map(i => i.totalDemurragePercent),
                    hoverBackgroundColor: colors,
                    backgroundColor: borderColors
                }
            ];

            return {
                labels: labels,
                datasets: datasets
            }
        },
        graphOptions() {
            const documentStyle = getComputedStyle(document.documentElement);
            const textColor = documentStyle.getPropertyValue('--text-color');

            return {
                plugins: {
                    legend: {
                        labels: {
                            usePointStyle: true,
                            color: textColor
                        }
                    }
                }
            };
        }
    },
    methods: {

    }
};
</script>

<template>
    <main>
        <Chart type="pie" :data="data" :options="graphOptions" :plugins="[pieLabelPlugin]" />
    </main>
</template>